import type { TFunction, TOptions } from 'i18next';

export function translationFactory(
  key: string | string[],
  options: {
    params?: TOptions;
    format?: (value: string) => string;
  } = {}
) {
  return (t: TFunction) => {
    const trans = t(key, options.params);

    return options.format ? options.format(trans) : trans;
  };
}

export const titleGetter = translationFactory;

export function detectTranslation(
  key: ((t: TFunction) => string) | string,
  t: TFunction
) {
  return typeof key === 'function' ? key(t) : key;
}
